import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { tabsFor } from '../nav';
import { useAdminAuth } from '../auth';

/**
 * The tab strip inside a section.
 *
 * Two levels of navigation, not one flat eleven: the top bar answers "which
 * area of the product", this answers "which view of that area". A tab can
 * carry a count badge (pending applications, failed crawls) so a section
 * needing attention says so from anywhere in the panel rather than only once
 * you've opened it.
 */
const base = 'relative -mb-px border-b-2 px-1 pb-2.5 text-sm font-medium transition-colors';
const on = 'border-raspberry-600 text-ink';
const off = 'border-transparent text-ink-secondary hover:border-hairline hover:text-ink';

export default function SubNav({ section, badges = {} }) {
  const { admin } = useAdminAuth();
  const { search } = useLocation();
  const tabs = tabsFor(section, admin?.role);

  if (tabs.length < 2) return null;

  return (
    <div className="mb-6 border-b border-hairline">
      <nav className="flex items-center gap-6" aria-label={`${section} views`}>
        {tabs.map((t) => {
          const count = t.badge ? badges[t.badge] : 0;
          return (
            <NavLink
              key={t.key}
              to={{ pathname: t.path, search }}
              end={t.end}
              className={({ isActive }) => `${base} ${isActive ? on : off}`}
            >
              <span className="inline-flex items-center gap-1.5">
                {t.label}
                {count > 0 && (
                  <span className="rounded-full bg-status-warning/15 px-1.5 py-0.5 text-[10px] font-semibold leading-none text-[#8a5a00]">
                    {count}
                  </span>
                )}
              </span>
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
}
